import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "./components/ArticleLayout";

export default function ArticleDetail() {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Header />
        <main className="bg-background-50">
          <div className="mx-auto w-full max-w-3xl px-4 py-24 text-center md:px-6">
            <h1 className="font-heading text-2xl font-bold text-foreground-950">
              {t("article.notFoundTitle")}
            </h1>
            <p className="mt-3 text-sm text-foreground-600">
              {t("article.notFound")}
            </p>
            <Link
              to="/"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              {t("article.backHome")}
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <ArticleLayout article={article} />
      <Footer />
    </>
  );
}